export default __webpack_public_path__ + "static/saw-50c7519b5897a301a470cb0a40d99ace.png";